<template>
  <div>
    <v-dialog v-model="message.status" fullscreen>
      <v-alert
        class="mx-auto my-12"
        max-width="374"
        v-model="message.status"
        dismissible
        prominent
        shaped
        :type="message.color"
      >{{ message.text }}
      </v-alert>
    </v-dialog>
    <v-tabs vertical>
      <v-tab v-for="permission in permissions" style="width: 200px" :key="permission.group">
        {{ permission.group }}
      </v-tab>
      <v-tab-item v-for="permission in permissions" :key="permission.group">
        <v-container>
          <v-row>
            <v-col v-for="page in permission.pages" cols="12" sm="12" md="6" lg="6" xl="6"
                   :key="page.uri+page.permissionName">
              <v-card
                elevation="1"
                :loading="loading"
                shaped
              >
                <v-card-title>
                  <h4>{{ page.title }}</h4>
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <v-list-group
                      v-for="widget in page.widgets"
                      :key="widget.permissionName+widget.title"

                      :value="true"
                      no-action
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <!--<v-list-item-title v-text="item.title"></v-list-item-title>-->
                          <v-switch
                            v-model="widget.model"
                            inset
                            :disabled="widget.permissionName===''"
                          ></v-switch>
                          {{ widget.title !== undefined ? widget.title : widget.permissionName !== '' ? widget.permissionName : 'نام و مجوز برای ویجت تعریف نشده است' }}
                          :
                          {{ widget.model.toString() === 'true' ? 'مجوز داده شد' : 'مجوز داده نشده' }}
                        </v-list-item-content>
                      </template>

                      <v-list-item
                        v-for="item in widget.items"
                        :key="item.title"
                      >
                        <v-list-item-content>
                          <!--<v-list-item-title v-text="child.title"></v-list-item-title>-->
                          <v-switch
                            v-model="item.model"
                            inset
                            :disabled="item.permissionName===''"
                          ></v-switch>
                          {{ item.title !== undefined ? item.title : item.permissionName !== '' ? item.permissionName : 'نام و مجوز برای ویجت تعریف نشده است' }}
                          :
                          {{ item.model.toString() === 'true' ? 'مجوز داده شد' : 'مجوز داده نشده' }}
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <v-btn
      color="primary"
      elevation="3"
      rounded
      x-large
      fixed
      bottom
      left
      class="mb-8"
      style="z-index: 9999"
      @click="returnPermission"
    >
      ذخیره مجوزهای نقش "{{ $route.params.role }}"
    </v-btn>
  </div>

</template>

<script>
import axios from "@axios";
import router from "@/router";
import baseConfig from "../../../baseConfig";

export default {
  name: 'Permission',
  data: () => (
    {
      loading : false,
      message: {
        status: false,
        text: "success operation",
        color: "success"
      },
      permissions: [],
    }),
  beforeCreate() {
    if (localStorage.getItem("accessToken")==="undefined" || localStorage.getItem("accessToken")===undefined || localStorage.getItem("accessToken")==="null" || localStorage.getItem("accessToken")===null || localStorage.getItem("accessToken")==="") {
      router.push('/login')
    }
  },
  async mounted() {
    await axios.get(baseConfig.baseUrl+'permissions/getWidgets').then(r => {
      this.permissions = r.data.data
    })
    await axios.get(baseConfig.baseUrl+'roles/getRolePermissions/'+ this.$route.params.role).then(r2 => {
      this.permissionsAssigned = r2.data.data
      // console.log(this.permissionsAssigned)
      //   console.log(this.permissions)
      this.permissions.map(g => g.pages.map(p=>  this.permissionsAssigned.includes(p.permissionName) ? p.model=true : p.model=false));
      this.permissions.map(g => g.pages.map(p=>  p.widgets.map(w => this.permissionsAssigned.includes(w.permissionName) ? w.model=true : w.model=false)));
      this.permissions.map(g => g.pages.map(p=>  p.widgets.map(w => w.items.map(i=> this.permissionsAssigned.includes(i.permissionName) ? i.model=true : i.model=false))));
    })
  }
  ,
  methods: {
    async returnPermission() {
      this.loading=true
      let sendResult = [];
      let sendResultUnPermission = [];
      this.permissions.map(p => p.pages.map(r => r.widgets.map(w => w.model === true ? sendResult.push(w.permissionName) : null)))
      this.permissions.map(p => p.pages.map(r => r.widgets.map(w => w.model === false ? sendResultUnPermission.push(w.permissionName) : null)))
      this.permissions.map(p => p.pages.map(r => r.widgets.map(w => w.items.map(i => i.model === true ? sendResult.push(i.permissionName) : null))))
      this.permissions.map(p => p.pages.map(r => r.widgets.map(w => w.items.map(i => i.model === false ? sendResultUnPermission.push(i.permissionName) : null))))
      await axios.post(baseConfig.baseUrl+'permissions/storeWidgets', {
        permissions: sendResult,
        unPermissions: sendResultUnPermission,
        role: this.$route.params.role
      }).then(r => {
        this.message = {
          status: true,
          text: "success operation",
          color: r.data.status==="success" ? "success" : "error"
        }
        setTimeout(() => {
          this.message.status = false
        }, 30000)
        this.loading=false
      })

    }
  }
}
</script>

<style scoped>

</style>
